import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const UserNotFoundError = BaseErrorSchema.extend({
  errorType: z.literal('UserNotFoundError'),
  id: z.string(),
});

export type UserNotFoundError = z.infer<typeof UserNotFoundError>;
